<template>
  <div>
    <div class="all-work__form">
      <div class="all-work__inside">
        <div class="all-work__blocks" v-if="is_show_filters">
          <filter-annotation-sub v-if="filters_counts.annotation=='y'"/>
          <filter-audioguides-sub v-if="filters_counts.audioguides=='y'"/>
          <!--<filter-interior-sub v-if="filters_counts.interior=='y'"/>-->
          <filter-insale-sub/>
        </div>

        <div class="all-work__boxes">
          <div class="all-work__filter" :style="is_show_filters?'':'margin-left:0'">
            <div class="all-artists-filter__item">
              <sort-type-sub/>
            </div>
          </div>

          <filter-search-sub/>
        </div>
      </div>
    </div>

    <div class="all-work__contents" id="id_main_works_list">
      <works-filter-sub
        :filters="filters"
        v-on:filterChanged="filterChanged"/>

      <div class="works-list works-list__container" style="width: 100%">
        <works-tags-sub/>

        <div v-show="worksLoading" style="margin-top: 40px">
          <preloader/>
        </div>
        <works-list v-show="!worksLoading" :is_mark_work_pro="is_mark_work_pro"/>
        <!--<div v-if="is_copyright" v-show="!worksLoading">
          {{ $t('message.ArtistCopyright') }}
        </div>-->

        <works-pagination-sub v-show="!worksLoading"/>
      </div>
    </div>
  </div>
</template>


<script>
  import FilterAnnotationSub from "../../_common/components/list/filter/FilterAnnotationSub";
  import FilterAudioguidesSub from "../../_common/components/list/filter/FilterAudioguidesSub";
  //import FilterInteriorSub from "../../_common/components/list/filter/FilterInteriorSub";
  import FilterInsaleSub from "../../_common/components/list/filter/FilterInsaleSub";
  import FilterSearchSub from "../../_common/components/list/filter/FilterSearchSub";
  import SortTypeSub from "../../_common/components/list/filter/SortTypeSub";
  import WorksFilterSub from "./list/WorksFilterSub";
  import WorksTagsSub from "./list/WorksTagsSub";
  import WorksList from "../../../components/list/WorksList";
  import WorksPaginationSub from "./list/WorksPaginationSub";
  import Preloader from "../../../components/Preloader";
  import WorksMix from "../../../components/WorksMix";
  import WorksFilterMix from "../../../components/list/WorksFilterMix";

  export default {
    components: {
      FilterAnnotationSub, FilterAudioguidesSub, /*FilterInteriorSub,*/ FilterInsaleSub, FilterSearchSub, SortTypeSub,
      WorksFilterSub, WorksTagsSub, WorksList, Preloader, WorksPaginationSub,
    },
    name      : 'works-sub',
    mixins: [WorksMix, WorksFilterMix],

    computed: {
      is_show_filters: {
        get () {
          return this.is_show_insale() || this.filters_counts.annotation=='y' || this.filters_counts.audioguides=='y'/* || this.filters_counts.interior=='y'*/;
        },
      }
    },

    methods: {
      is_show_insale(){
        if ( window._GL_works_insale==='n' ) return false;
        return this.$store.getters.is_sale_enable;
      },
    },

    created   : function () {
      this.$store.dispatch ('addUsedFilters', 'Saletypes');
      this.$store.dispatch ('addUsedFilters', 'FiltersCounts');
    },
    destroyed : function () {
      this.$store.dispatch ('removeUsedFilters', 'Saletypes');
      this.$store.dispatch ('removeUsedFilters', 'FiltersCounts');
    },
  }
</script>



// WEBPACK FOOTER //
// src/sub/air_light/components/WorksSub.vue